/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { TaskV2 } from '../model/taskV2';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class BillingPipelineOperatorService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Trigger and refresh billing pipeline on V4/V3 hybrid schema automatically by each module
     * Trigger and refresh billing pipeline on V4/V3 hybrid schema automatically with enabled billing module.
     * @param updateIncortaSubscription Boolean flag to update incorta subscription table
     * @param updateSubscriptionHistory Boolean flag to update subscription history table by core processor from Incorta source
     * @param updateProcessedSubscription Boolean flag to update processed subscription table
     * @param updateEventHistory Boolean flag to pull events from vcdrsp.billing_event table
     * @param updateBillingEntities Boolean flag to process billing events into generation-based billing entities
     * @param updateRawUsage Boolean flag to download raw usage data from S3/GCS buckets
     * @param upsertSddcQuota Boolean flag to upsert SDDC Quota entries for new orgs
     * @param updateEntityAndOrgSummary Boolean flag to run daily entity and org summary update
     * @param updateOrgOverageEnforcement Boolean flag to run daily org overage enforcement update
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public postRefreshPipelineV4Operator(updateIncortaSubscription: boolean, updateSubscriptionHistory: boolean, updateProcessedSubscription: boolean, updateEventHistory: boolean, updateBillingEntities: boolean, updateRawUsage: boolean, upsertSddcQuota: boolean, updateEntityAndOrgSummary: boolean, updateOrgOverageEnforcement: boolean, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<TaskV2>;
    public postRefreshPipelineV4Operator(updateIncortaSubscription: boolean, updateSubscriptionHistory: boolean, updateProcessedSubscription: boolean, updateEventHistory: boolean, updateBillingEntities: boolean, updateRawUsage: boolean, upsertSddcQuota: boolean, updateEntityAndOrgSummary: boolean, updateOrgOverageEnforcement: boolean, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<TaskV2>>;
    public postRefreshPipelineV4Operator(updateIncortaSubscription: boolean, updateSubscriptionHistory: boolean, updateProcessedSubscription: boolean, updateEventHistory: boolean, updateBillingEntities: boolean, updateRawUsage: boolean, upsertSddcQuota: boolean, updateEntityAndOrgSummary: boolean, updateOrgOverageEnforcement: boolean, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<TaskV2>>;
    public postRefreshPipelineV4Operator(updateIncortaSubscription: boolean, updateSubscriptionHistory: boolean, updateProcessedSubscription: boolean, updateEventHistory: boolean, updateBillingEntities: boolean, updateRawUsage: boolean, upsertSddcQuota: boolean, updateEntityAndOrgSummary: boolean, updateOrgOverageEnforcement: boolean, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (updateIncortaSubscription === null || updateIncortaSubscription === undefined) {
            throw new Error('Required parameter updateIncortaSubscription was null or undefined when calling postRefreshPipelineV4Operator.');
        }
        if (updateSubscriptionHistory === null || updateSubscriptionHistory === undefined) {
            throw new Error('Required parameter updateSubscriptionHistory was null or undefined when calling postRefreshPipelineV4Operator.');
        }
        if (updateProcessedSubscription === null || updateProcessedSubscription === undefined) {
            throw new Error('Required parameter updateProcessedSubscription was null or undefined when calling postRefreshPipelineV4Operator.');
        }
        if (updateEventHistory === null || updateEventHistory === undefined) {
            throw new Error('Required parameter updateEventHistory was null or undefined when calling postRefreshPipelineV4Operator.');
        }
        if (updateBillingEntities === null || updateBillingEntities === undefined) {
            throw new Error('Required parameter updateBillingEntities was null or undefined when calling postRefreshPipelineV4Operator.');
        }
        if (updateRawUsage === null || updateRawUsage === undefined) {
            throw new Error('Required parameter updateRawUsage was null or undefined when calling postRefreshPipelineV4Operator.');
        }
        if (upsertSddcQuota === null || upsertSddcQuota === undefined) {
            throw new Error('Required parameter upsertSddcQuota was null or undefined when calling postRefreshPipelineV4Operator.');
        }
        if (updateEntityAndOrgSummary === null || updateEntityAndOrgSummary === undefined) {
            throw new Error('Required parameter updateEntityAndOrgSummary was null or undefined when calling postRefreshPipelineV4Operator.');
        }
        if (updateOrgOverageEnforcement === null || updateOrgOverageEnforcement === undefined) {
            throw new Error('Required parameter updateOrgOverageEnforcement was null or undefined when calling postRefreshPipelineV4Operator.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>updateIncortaSubscription, 'update-incorta-subscription');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>updateSubscriptionHistory, 'update-subscription-history');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>updateProcessedSubscription, 'update-processed-subscription');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>updateEventHistory, 'update-event-history');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>updateBillingEntities, 'update-billing-entities');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>updateRawUsage, 'update-raw-usage');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>upsertSddcQuota, 'upsert-sddc-quota');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>updateEntityAndOrgSummary, 'update-entity-and-org-summary');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>updateOrgOverageEnforcement, 'update-org-overage-enforcement');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/v4/pipeline/refresh`;
        return this.httpClient.request<TaskV2>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

}
